
import { Env } from './Env';

export const config = {} as any;

export const setConfig = (newConfig: any) => {
  for (const key in newConfig) {
    config[key] = newConfig[key];
  }
};

export const isDevEnv = () => config.NX_PUBLIC_ENV === Env.dev;
export const isTestEnv = () => config.NX_PUBLIC_ENV === Env.test;

export const ISABEL_LINK = 'www.isabelhealthcare.com';
export const ISABEL_PAIN_MAX_SCORE = 150;

export const MIN_FILES_TO_SHOW = 4;
